import { Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { isEmpty } from 'lodash'
import React from 'react'

import CowmedChip from '#/components/Chip'
import { contrastColor } from '#/utils/contrastColor'

const Wrapper = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 5,
  margin: '5px 0',
})

function TypePortfolio({ portfolios }) {
  if (isEmpty(portfolios)) return null

  return (
    // sei que é nada a ver, mas não achei outro jeito de manter isso decente pra ser mostrado
    <Wrapper sx={{ minWidth: portfolios?.length > 1 ? 185 : 92 }}>
      {portfolios?.map(portfolio => (
        <div key={portfolio.name} style={{ boxSizing: 'border-box' }}>
          <Tooltip title={portfolio.name}>
            <div>
              <CowmedChip
                value={portfolio.name}
                size="small"
                width="90px"
                style={{
                  backgroundColor: portfolio.color,
                  color: contrastColor(portfolio.color),
                }}
              />
            </div>
          </Tooltip>
        </div>
      ))}
    </Wrapper>
  )
}

export default TypePortfolio
